import { Box, Icon, List, ListItemAvatar, ListItemButton, ListItemText, Unstable_Grid2 as Grid, Typography, Paper, Checkbox, ListItem, ListItemIcon, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { DropdownModel, Menu } from "../../../data/interfaces/sharedmodels";
import configService from "../../../data/api/config.service";
import { TocMenus, TocRole } from "../../../data/interfaces/configurationmodels";
import { useAppDispatch } from "../../../stores/hooks";
import { showsuccessmessage, showwarningmessage } from "../../../stores/notificationslice";


export default function MenuConfig() {
    const dispatch=useAppDispatch();
    const [menus, setMenus] = useState<Menu[]>([]);
    const [tocMenus, setTocMenus] = useState<TocMenus>({Roles:[],TocRoles:[]});
    const [selectedMenu, setSelectedMenu] = useState<number>(0);
    const [selectedToc, setSelectedToc] = useState<number>(0);
    useEffect(() => {
        configService.getMenus().then((response) => {
            setMenus(response.data);
        });
        loadTocmenus();
    }, []);

    const loadTocmenus=()=>{
        configService.getTocMenus().then((response) => {
            setTocMenus(response.data);
        });
    }

    useEffect(() => {
        if (menus && menus.length && selectedMenu < 1) {
            setSelectedMenu(menus[0].Id);
        }
    }, [menus]);

    useEffect(() => {
        if (tocMenus && tocMenus.TocRoles.length && selectedToc < 1) {
            setSelectedToc(tocMenus.TocRoles[0].TocId);
        }
    }, [tocMenus]);

    const handleOnToggleRole = (checked: boolean, role: DropdownModel) => {
        let tempTocmenus:TocMenus = { ...tocMenus };
        if (tempTocmenus.TocRoles && tempTocmenus.TocRoles.filter(a => a.TocId == selectedToc)[0]
            .TocRoleMenus.findIndex(m => m.MenuId == selectedMenu && m.RoleId.toString() == role.Id) > -1) {

            tempTocmenus.TocRoles.filter(a => a.TocId == selectedToc)[0]
                .TocRoleMenus.filter(m => m.MenuId == selectedMenu && m.RoleId.toString() == role.Id)[0].IsDeleted = !checked;

        }
        else {
            tempTocmenus.TocRoles?.filter(a => a.TocId == selectedToc)[0]
                .TocRoleMenus.push({Id:null,RoleId:Number.parseInt(role.Id),Description:null,IsDeleted:false,MenuId:selectedMenu});
        }
        setTocMenus(tempTocmenus);
    }

    const handleSave=()=>{
        
        if(tocMenus.TocRoles.findIndex(a=>a.TocRoleMenus.findIndex(b=>(b.Id==null&&!b.IsDeleted)||(b.Id!=null&& b.IsDeleted))>-1)<0){
            dispatch(showwarningmessage("No data has changed."));return;
        }
        

        let tocRoles=tocMenus.TocRoles.filter(a=>a.TocRoleMenus.findIndex(b=>(b.Id==null&&!b.IsDeleted)||(b.Id!=null&& b.IsDeleted))>-1);
        configService.updateTocMenus(tocRoles).then((response)=>{
            loadTocmenus();
            dispatch(showsuccessmessage("The menu data saved successfully."));
        })
    }

    return (
        <Box component={Paper} sx={{mt:2}}>
        <Grid container spacing={2} >
            <Grid xs={4}>
                <Box component={Paper} sx={{ p:2  }}>
                    <Typography variant="h6">Menus</Typography>
                    <List disablePadding={true}>
                        {
                            menus.map(function (menu) {
                                return (
                                    <ListItemButton key={menu.Id} selected={selectedMenu === menu.Id}
                                        onClick={(event) => setSelectedMenu(menu.Id)}>
                                        <ListItemAvatar >
                                            <Icon>{menu.Icon}</Icon>
                                        </ListItemAvatar>
                                        <ListItemText primary={menu.Description} />
                                    </ListItemButton>)
                            })
                        }
                    </List>
                </Box>
            </Grid>
            <Grid xs={4}>
                <Box component={Paper} sx={{p:2  }}>
                <Typography variant="h6">TOCs</Typography>
                    <List disablePadding={true}>
                        {
                            tocMenus?.TocRoles.map(function (toc) {
                                return (
                                    <ListItemButton key={toc.TocId} selected={selectedToc === toc.TocId}
                                        onClick={(event) => setSelectedToc(toc.TocId)}>
                                        <ListItemText primary={toc.TocName} />
                                    </ListItemButton>)
                            })
                        }
                    </List>
                </Box>
            </Grid>
            <Grid xs={4}>
                <Box component={Paper} sx={{ p:2}}>
                    <Typography variant="h6">Roles</Typography>
                    <List disablePadding={true}>
                        {tocMenus && tocMenus?.TocRoles.length && selectedToc ?
                            tocMenus.Roles.map(function (role) {
                                return (
                                    <ListItem key={role.Id}>
                                        <ListItemButton >
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    onChange={(e)=>handleOnToggleRole(e.target.checked,role)}
                                                    checked={tocMenus.TocRoles.filter(a => a.TocId == selectedToc)[0].TocRoleMenus.findIndex(b => b.MenuId == selectedMenu && b.RoleId.toString() == role.Id&&b.IsDeleted==false) > -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby': role.Description }} />
                                            </ListItemIcon>
                                            <ListItemText primary={role.Description} />
                                        </ListItemButton>
                                    </ListItem>
                                )
                            })
                            : null}
                    </List>
                </Box>
            </Grid>
            <Grid xs={12}>
                <Button variant="contained"  sx={{float:"right",m:2}} onClick={handleSave}>Save All Changes</Button>
            </Grid>
        </Grid>
        </Box>
    )
}